import { app } from '@lobby/store/app';
import { socket } from '@lobby/store/socket';
import { EMPTY, of } from 'rxjs';

import { CODES, PLAYER_BLOCKED } from '@ezugi/constants/errors';
import { BLOCKED_PLAYER, PLAYER_FINANCIAL_HISTORY } from '@ezugi/constants/gameSocketMessages';

const NEED_RELOGIN = 'needRelogin';

export default function handleErrors(socketMessage) {
  const { MessageType, errorDescription } = socketMessage;

  switch (MessageType) {
  case PLAYER_FINANCIAL_HISTORY: {
    return errorDescription === NEED_RELOGIN
      ? of(
        app.update({
          error: {
            code: 105, // Show authentication error
          },
        }),
      )
      : EMPTY;
  }
  case BLOCKED_PLAYER: {
    return of(
      app.update({ error: { code: CODES[PLAYER_BLOCKED] } }),
      socket.close(),
    );
  }
  default:
    break;
  }
}
